/**
 * Notification Service — API calls for the unified `/notifications` resource
 * (list, mark-read, delete, and user-configurable preferences).
 */
import { apiClient } from "./apiService";

export const getNotifications = (params = {}) =>
  apiClient.get("/notifications", { params });

export const getUnreadCount = () => apiClient.get("/notifications/unread-count");

export const markNotificationsRead = (ids = null) =>
  apiClient.put("/notifications/mark-read", ids ? { ids } : {});

export const markNotificationRead = (id) =>
  apiClient.put(`/notifications/${id}/read`);

export const deleteNotification = (id) => apiClient.delete(`/notifications/${id}`);

export const getNotificationPreferences = () => apiClient.get("/notifications/preferences");

export const updateNotificationPreferences = (updates) =>
  apiClient.put("/notifications/preferences", updates);
